import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_nvprwdg7p9: FaireCollectionEntity = {
  token: "pbc_nvprwdg7p9",
  type: "collection",
  name: "Judy Blue Spring Summer ’26 Essentials",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14ac62b4c4d3b078b42e42aab8979b5bc09def6c8fade8bc901c1a2055b2b1e7.jpeg",
  itemCount: 77,
  description:
    "Built on our best-selling fits, Judy Blue Spring Summer 2026 introduces fresh shorts, elevated workwear details, western touches, and playful prints. From Rigid Magic to Featherweight fabrics, this collection delivers trend-driven style, comfort, and our signature flattering fit.",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:15.468Z",
    importedBy: "entity-db-import-collections",
  },
};
